<template>
  <div id="app">
    <Header></Header>
    <div class="container">
      <router-view />
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
export default {
  data: function() {
    return {
      isDark: this.$store.getters.user.isDark
    }; //ユーザー情報のdocを取得してpropsで子要素に渡す
  },
  components: {
    Header,
    Footer
  },
  methods: {},
  created() {
    //DOM生成前
    this.$root.$on("bodyDark", function() {
      document.body.classList.add("dark-theme");
    });
  },
  mounted() {
    //DOM生成後
    if (this.isDark) {
      this.$root.$emit("bodyDark");
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  z-index: -3;
}
.container {
  width: auto;
  margin-bottom: 130px;
}
.dark-theme {
  #app {
    color: white;
  }
  .title-card {
    background-color: rgba(52, 58, 64, 0.9);
  }
  .title-card h1 {
    color: white;
  }
  .title-card h3 {
    color: white;
  }
  .title-card a {
    color: skyblue;
  }
  .user-name {
    color: #2c3e50;
  }
  .question-card {
    background-color: rgba(52, 58, 64, 0.9) !important;
  }
  .answer-text {
    background-color: rgba(255, 255, 255, 0.1);
  }
  .page-line {
    background-color: rgba(255, 255, 255, 0.1);
  }
  .question-post {
    background-color: rgba(52, 58, 64, 0.9) !important;
  }
  .book-info {
    background-color: rgba(255, 255, 255, 0.1);
  }
  .book-card {
    background-color: rgba(52, 58, 64, 0.9) !important;
  }
  .carousel-card {
    color: white;
  }
  .exp-wrapper {
    background-color: rgba(52, 58, 64, 0.562);
  }
  .exp-wrapper h1 {
    color: white;
  }
  .exp-wrapper p {
    color: white;
  }
  .candidate {
    background-color: rgba(75, 80, 85, 0.95);
  }
  .simple-card {
    background-color: rgba(75, 80, 85, 0.95) !important;
  }
  .simple-card-comment {
    background-color: rgba(55, 61, 67, 0.95);
  }
  .simple-card-book {
    background-color: rgba(55, 61, 67, 0.5);
  }
  .comment-wrapper {
    background-color: rgba(75, 80, 85, 0.95);
  }
  .comment-button {
    background-color: rgba(75, 80, 85, 0.95);
  }
  .comment-area .card-body {
    background-color: rgba(75, 80, 85, 0.95);
  }
  background-color: rgba(75, 80, 85, 0.95);
}
</style>
